/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
    // {
    //     url: "/",
    //     name: "Kezdőlap",
    //     slug: "kezdolap",
    //     icon: "HomeIcon",
    // },
    {
        url: "",
        name: "Ügyletek",
        slug: "ugyletek",
        icon: "FolderIcon",
        onlyAdmin: false,
        submenu: [{
                url: '/ugyletek',
                name: "Lista",
                slug: "ugyletek",
                icon: "ListIcon",
            },
            {
                url: '/ugyletek/uj',
                name: "Új ügylet",
                slug: "/ugyletek/uj",
                icon: "PlusIcon",
            },
        ]
    },
    {
        url: "",
        name: "Megrendelők",
        slug: "megrendelok",
        icon: "CornerLeftDownIcon",
        onlyAdmin: false,
        submenu: [{
                url: '/megrendelok',
                name: "Lista",
                slug: "megrendelok",
                icon: "ListIcon",
            },
            {
                url: '/megrendelok/uj',
                name: "Új megrendelő",
                slug: "/megrendelok/uj",
                icon: "PlusIcon",
            },
        ]
    },
    {
        url: "/dolgozok",
        name: "Dolgozók",
        slug: "dolgozok",
        icon: "UserIcon",
        onlyAdmin: true,
    },
    {
        url: "/ugylet-tipusok",
        name: "Ügylet típusok",
        slug: "ugylet-tipusok",
        icon: "TagIcon",
        onlyAdmin: true
    },
    {
        url: "/statisztika",
        name: "Statisztika",
        slug: "statisztika",
        icon: "BarChart2Icon",
        onlyAdmin: false
    }
]